import { VehiculoRepository } from '../../Domain/VehiculoRepository'
import { Matricula } from '../../Domain/Matricula'
import { Vehicle } from '../../../../../../common/types/Vehiculo'
import { apiVehiculo } from '../api/apiVehiculo'

export const VehiculoApiRepository: VehiculoRepository = {
  async obtenerPorMatricula(matricula: Matricula): Promise<Vehicle[] | null> {
    try {
      return await apiVehiculo.obtenerPorMatricula(matricula)
    } catch (e) {
      console.error('Error al obtener vehículo:', e)
      return null
    }
  },
}
